import React, { Component } from 'react'
import {Card, CardBody, Button, CardTitle,Row, Col } from 'reactstrap'
import CardHeader from 'reactstrap/lib/CardHeader'
import { Field, FieldArray, reduxForm } from 'redux-form'
import { renderInput,renderInputField } from '../../common/renderinput'
import validate from './validate'


const renderMembers = ({ fields }) => (
    <div>
      <div className="text-right">
        <button  className="btn btn-primary" type="button" onClick={() => fields.push({})}>+</button>
      </div>
      {fields.map((member, index) =>

         <div  className="form-group">
             <Row>
             
             <Col md={2}>
                <Field
                    name={`${member}.LicNumber`}
                    type="text"
                    component={renderInputField}
                    label="License Number"/>
            </Col>
             <Col md={2}>
                <Field
                    name={`${member}.HolderName`}
                    type="text"
                    component={renderInputField}
                    label="Holder Name"/>
            </Col>
            <Col md={2}>
                <Field
                    name={`${member}.EffectiveDate`}
                    type="text"
                    component={renderInputField}
                    label="Effective Date"/>
            </Col>
            <Col md={2}>
                <Field
                    name={`${member}.ExpirationDate`}
                    type="text"
                    component={renderInputField}
                    label="Expiration Date"/>
            </Col>
            <Col md={2}>
                <Field
                    name={`${member}.State`}
                    type="text"
                    component={renderInputField}
                    label="State"/>
            </Col>
            <Col md={1}>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        title="-"
                        onClick={() => fields.remove(index)}>-
                    </button>
             </Col>
            </Row>
        </div>
     
      )}
    </div>
  )
class LicenseForm extends Component {
    render(){
        const { handleSubmit, pristine, previousPage, submitting } = this.props
        return(
            <>
            <form onSubmit={this.props.handleSubmit(this.props.mainSubmit)}>
            <Row form>
                    <Col md={12}>
                    <Card className="w-100">
                            <CardHeader>License</CardHeader>
                        <CardBody>
                            <FieldArray name="members" component={renderMembers}/>
                        </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Card className="col-12 mb-3">
          <CardBody>
            <div className="text-right">
                <Button
                  style={{ marginRight: 16 }}
                  type="button"
                  onClick={this.props.previousPage}>
                  Previous
                </Button>
              <Button type="submit" disabled={pristine || submitting}>Next</Button>
            </div>
          </CardBody>
        </Card>
      </form>
                
            </>
        )
    }
}

export default reduxForm({
    form: 'CreateVendorForm', // <------ same form name
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
  })(LicenseForm)